<script lang="ts" setup>
import dayjs from 'dayjs';
import {
  formatDateForComment,
  formatDateTime,
  showRelativeTime,
} from '@/utils/formatters';

const props = withDefaults(
  defineProps<{
    datetime: string;
    hideTooltip?: boolean;
  }>(),
  {
    hideTooltip: false,
  },
);

const day = dayjs(props.datetime);
const showTooltip = !props.hideTooltip && showRelativeTime(day);
</script>

<template>
  <span v-if="showTooltip" v-tooltip.top="formatDateTime(datetime)">{{
    formatDateForComment(datetime)
  }}</span
  ><span v-else>{{ formatDateForComment(datetime) }}</span>
</template>
